module.exports = __webpack_public_path__ + "img/bg25.23ee9aca.png";